import seo from '@/core/data/landingSeo.json'

const L = seo.locales.en

// SEO 字段改为引用 landingSeo.json（见 Review 报告 §11.3 单一事实源）。
// keywords 已按 §11.5.2 移除（搜索引擎不依赖，继续双源维护无收益）。
export default {
  description: L.description,
  ogTitle: L.ogTitle,
  ogDescription: L.ogDescription,
  robots: 'index, follow',
  author: 'PhotoScope',
  canonical: 'https://photoscope.cc/{lang}',
  ogSiteName: 'PhotoScope',
  ogType: 'website',
  ogImage: seo.siteBaseUrl + seo.defaultOgImagePath,
  ogLocale: L.ogLocale,
}
